export function formatCpfCnpj(value, personType) {
  const cpf = personType === "fisica"

  if (cpf) {
    const digits = String(value || "").replace(/\D/g, "").slice(0, 11)
    return digits
      .replace(/^(\d{3})(\d)/, "$1.$2")
      .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4")
  }

  const clean = String(value || "").toUpperCase().replace(/[^A-Z0-9]/g, "")
  const registration = clean.slice(0, 12)
  const checkDigits = clean.slice(12).replace(/\D/g, "").slice(0, 2)

  return `${registration}${checkDigits}`
    .replace(/^(.{2})(.)/, "$1.$2")
    .replace(/^(.{2})\.(.{3})(.)/, "$1.$2.$3")
    .replace(/^(.{2})\.(.{3})\.(.{3})(.)/, "$1.$2.$3/$4")
    .replace(/^(.{2})\.(.{3})\.(.{3})\/(.{4})(\d)/, "$1.$2.$3/$4-$5")
}
